import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDiamondFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M7.984 5.333h16.032a1.12 1.12 0 0 1 .91.464l4.3 5.912a.56.56 0 0 1-.042.712l-12.77 13.834a.56.56 0 0 1-.794.032q-.012-.01-12.803-13.867a.56.56 0 0 1-.042-.712l4.3-5.912a1.13 1.13 0 0 1 .909-.463" })
});
export default SvgDiamondFilled;
